import { Box } from '@mui/material';
import ManageMealTable from './ManageMealTable';

/**
 * Main container component for Manage Meal page
 * Renders the page title and meal management table
 */
const ManageMeal = () => {
  return (
    <Box sx={{ p: 3 }}>
      <ManageMealTable />
    </Box>
  );
};

export default ManageMeal;
